/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function ChangeRequestOpen({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M6.6 3.5c0 1.23-.853 2.26-2 2.53v3.94a2.601 2.601 0 1 1-1.2 0V6.03A2.601 2.601 0 1 1 6.6 3.5Zm-4 0a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0ZM4 11.1a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8ZM9.4 12.5c0-1.23.853-2.26 2-2.53V2.949L9.424 4.924a.6.6 0 0 1-.848-.848l3-3a.6.6 0 0 1 .848 0l3 3a.6.6 0 0 1-.848.848L12.6 2.95v7.02A2.601 2.601 0 1 1 9.4 12.5Zm1.2 0a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0Z" clipRule="evenodd" /></svg>;
}
;